import Generator from './js-calendar';

export default {
  Generator: Generator
};